import { useTranslation } from 'react-i18next';

import styled from 'styled-components';

import type { Resource, TagFilter } from '../types';
import { getOptionText, parseTag } from '../utils';
import { LoadingItem } from './loading-item';
import { PopoverCard } from './popover-card';
import { StyleItem, StyleScrollbar } from './styles-base';

type CombineFilter = TagFilter & Partial<Resource>;

interface FilterSelectProps {
  filter: CombineFilter;
  inputValue?: string;
  onAddTag?: (tag: string, key: string, value: any) => void;
  onCloseDropdown?: () => void;
}

export function FilterSelect({ filter, inputValue, onAddTag, onCloseDropdown }: FilterSelectProps) {
  const { t } = useTranslation();
  const { options = [], loading = false } = filter;
  const parsedInput = parseTag(inputValue || '');
  const searchValue = parsedInput?.value.toLowerCase();
  // 复用标签输入框中冒号后的内容，输入变化时即时筛选当前下拉选项。
  const filteredOptions = searchValue ? options.filter((option) => getOptionText(option).toLowerCase().includes(searchValue)) : options;

  const handleOptionClick = (option: { label: any; value: string; text?: string }) => {
    if (parsedInput?.label) {
      const tag = `${parsedInput.label}: ${getOptionText(option)}`;
      onAddTag?.(tag, filter.key, option.value);
      onCloseDropdown?.();
    }
  };

  if (options?.length === 0 && !loading) return null;
  return (
    <PopoverCard>
      <MenuList>
        {loading ? (
          <LoadingItem />
        ) : (
          <>
            {filteredOptions.map((option) => (
              <MenuItem key={option.value} onClick={() => handleOptionClick(option)}>
                {option.label}
              </MenuItem>
            ))}
            {filteredOptions.length === 0 && <NoDataItem>{t('actions:search.option.not-found')}</NoDataItem>}
          </>
        )}
      </MenuList>
    </PopoverCard>
  );
}

/** ============================ styles ==================================== */
const MenuList = styled(StyleScrollbar)`
  overflow-y: auto;
  max-height: 300px;
  overflow-x: hidden;
  border-radius: inherit;
`;

const MenuItem = styled(StyleItem)``;

const NoDataItem = styled.div`
  padding: 8px 12px;
  color: var(--color-text-3);
  text-align: center;
`;
